import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
import MUIAccordionDetails from "@mui/material/AccordionDetails";
export var ELSAccordionDetails = function ELSAccordionDetails(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MUIAccordionDetails, _extends({
    className: "es-accordion-details ".concat(className || "")
  }, props), props.children);
};